/**
 * 礼品汇（allsmart）订单超时规则确认工具
 * 用于活动提交和费用追加前，检查费用归属中是否包含礼品汇订单并弹出确认弹窗
 */

/**
 * 检查费用归属表格数据中是否包含礼品汇订单
 * @param {Array} tableData - 费用归属表格数据
 * @returns {boolean}
 */
export function hasAllsmartOrder (tableData) {
  if (!tableData || !Array.isArray(tableData)) return false;
  return tableData.some(row => row.allsmartOrderVOList && row.allsmartOrderVOList.length > 0);
}

/**
 * 若包含礼品汇订单，弹出超时规则确认弹窗
 * @param {Vue} vm - Vue 实例（this）
 * @param {boolean} hasOrder - 是否包含礼品汇订单
 * @returns {Promise<boolean>} 用户确认返回 true，取消返回 false
 */
export function confirmAllsmartOrderTimeout (vm, hasOrder) {
  if (!hasOrder) return Promise.resolve(true);
  return vm.$confirm(
    '你申请的活动包含礼品库物料申请，如在30天内活动未完成审批，礼品库将会自动释放库存，释放库存后礼品将不会发货。请关注活动审批进度。',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => true).catch(() => false);
}
